import { Individual } from "../individual/Individual";
import { Location } from "../location/Location";
import { AssignedUser, DefaultAssignedUser } from "./AssignedUser";
import { DefaultDirectorResponseAction, DirectorResponseAction } from "./DirectorResponseAction";
import { FollowUp, DefaultFollowUp } from "./FollowUp";
import { DirectorResponseItem } from "./DirectorResponseItem";
import { IncidentComment } from "./IncidentComment";
import { DefaultIncidentTypeDetail, IncidentTypeDetail } from "./IncidentTypeDetail";
import { MedicationDetail, DefaultMedicationDetail } from "./MedicationDetail";
import { VarianceDocument } from "./VarianceDocuments";


export interface VarianceRequest {
  id: string;
  center: string;
  status: string;
  incidentDate: Date;
  reportingDepartment: string;
  department: string;
  location: Location;
  locationDetails: Location;
  individual: Individual;
  priority: string;
  incidentType: string | "UNKNOWN";
  incidentTypeDetails: IncidentTypeDetail[];
  incidentSubTypeDetails?: IncidentTypeDetail[];
  medicationDetail: MedicationDetail;
  description?: string;
  directorResponse: string;
  directorResponseBy?: string;
  directorResponseDate?: Date;
  directorResponseAction?: DirectorResponseAction;
  directorResponses: DirectorResponseItem[];
  completeDate?: Date;
  followUp?: FollowUp;
  witnesses?: Individual[];
  comments: IncidentComment[];
  assignedTo?: AssignedUser;
  createdBy: string;
  varianceStartDate: string;
  assignedUsers: AssignedUser[];
  severity?: string;
  incidentDisplayNumber?: string;
  incidentDisplayStatus?: string;
  documents: VarianceDocument[];
}

export function DefaultVarianceRequest(): VarianceRequest {
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  return {
    id: "",
    center: "",
    status: "",
    incidentDate: sixMonthsAgo,
    reportingDepartment: "",
    department: "",
    priority: "Standard",
    location: new Location(),
    locationDetails: new Location(),
    individual: new Individual(),
    incidentType: "UNKNOWN",
    incidentTypeDetails: [DefaultIncidentTypeDetail()],
    medicationDetail: DefaultMedicationDetail(),
    description: "",
    directorResponse: "",
    directorResponseAction: DefaultDirectorResponseAction(),
    directorResponses: [],
    followUp: DefaultFollowUp(),
    witnesses: [],
    comments: [],
    assignedTo: DefaultAssignedUser(),
    createdBy: "",
    varianceStartDate: "",
    assignedUsers: [],
    severity: "",
    incidentDisplayNumber: "",
    incidentDisplayStatus: "",
    documents: [],
  };
}
